import React from "react";

function CustomDivider(props){
    const style = props?.style?props.style:{}

  return  <hr style={{  borderTop:"1px rgb(200,200,200)  solid ",margin: "30px 0" ,...style}} />

}

export  default CustomDivider
